import { render } from "./Spacing.vue?vue&type=template&id=20ce9606"
import script from "./Spacing.vue?vue&type=script&lang=js"
export * from "./Spacing.vue?vue&type=script&lang=js"
script.render = render

export default script